import { render, staticRenderFns } from "./UsuarioRegistra.vue?vue&type=template&id=d819f7ee&"
import script from "./UsuarioRegistra.vue?vue&type=script&lang=js&"
export * from "./UsuarioRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports